
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"40","height":"40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke":"#FF6F4F","stroke-width":"2","stroke-miterlimit":"10"}},[_c('path',{attrs:{"d":"M5.36 15.82c1.856 0 3.36-1.5 3.36-3.35S7.216 9.12 5.36 9.12C3.504 9.12 2 10.62 2 12.47s1.504 3.35 3.36 3.35zM32.89 15.82c1.856 0 3.36-1.5 3.36-3.35s-1.504-3.35-3.36-3.35c-1.856 0-3.36 1.5-3.36 3.35s1.504 3.35 3.36 3.35zM13.52 8.2c1.856 0 3.36-1.5 3.36-3.35S15.376 1.5 13.52 1.5c-1.856 0-3.36 1.5-3.36 3.35s1.504 3.35 3.36 3.35zM24.73 8.2c1.856 0 3.36-1.5 3.36-3.35S26.586 1.5 24.73 1.5c-1.856 0-3.36 1.5-3.36 3.35s1.504 3.35 3.36 3.35zM27.29 18.34c-2.5-3.54-5.78-6.46-8.16-6.46-4.36 0-11.76 9.78-11.76 15.33a3.36 3.36 0 003.36 3.36c2.52 0 5-2.52 8.4-2.52"}}),_c('path',{attrs:{"d":"M28.07 38.5c5.484 0 9.93-4.441 9.93-9.92s-4.446-9.92-9.93-9.92-9.93 4.441-9.93 9.92 4.446 9.92 9.93 9.92zM24.59 32.05l6.95-6.94M31.54 32.05l-6.95-6.94"}})])])
          )
        }
      }
    